module.exports = __webpack_public_path__ + "img/box6.9d1dfc59.png";